import { Component, EventEmitter, HostListener, Input, OnInit, Output, OnChanges, SimpleChanges, OnDestroy } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { UtilService, VwoService, VariablesService, ScriptLoaderService, EventsService } from '../../../../shared/services';
import { PaymentUtilService } from '../../services';
import { ICart } from '../../models/cart.model';
import { ICard } from '../../models/card.model';
import { Location } from '@angular/common';
import { Subscription } from 'rxjs';

declare let cardValidator;
@Component({
  selector: 'app-cards',
  templateUrl: './cards.component.html',
  styleUrls: ['./cards.component.scss']
})
export class CardsComponent implements OnInit, OnChanges, OnDestroy {

  @Input() amount;
  @Input() option;
  @Input() isOrderLoading;
  @Input() showBtn = true;
  @Input() showZip;
  @Input() fullName;
  @Input() showBackBtn;
  @Input() type;
  @Input() currency;
  @Input() btnClass = 'submit-payment';
  @Input() donateBtnLabel = 'Pay';
  @Input() hidePledgeBtnAmount;
  @Input() showPrefMethodText;
  @Input() cartDetails;
  @Output() dataEmit: EventEmitter<any> = new EventEmitter();
  isMobile: any;
  cartResponse: ICart;

  cardForm: FormGroup;
  cardNumber: FormControl;
  cardExpiry: FormControl;
  cardCvv: FormControl;
  nameOnCard: FormControl;
  zipcode: FormControl;
  expiryNumber;
  cardType;
  card;
  cardDetails: ICard;
  cardNumberMask = '0000 0000 0000 0000';
  cardPrefix = '';
  cardCvvMask = '000';
  addedValidCard;
  addedCard;
  lastOrderInfo = {
    show: false,
    last4: '',
    customer_id: '',
    mode_value: ''
  };
  userdata;
  subs: Subscription[] = [];
  constructor(
    private utilService: UtilService,
    public paymentUtilService: PaymentUtilService,
    private variablesService: VariablesService,
    public vwo: VwoService,
    public location: Location,
    public script: ScriptLoaderService,
    private events: EventsService
  ) { }

  ngOnInit() {
    this.isMobile = this.utilService.isMobile();
    this.script.loadScript('card-validator').then(() => this.getCartDetails());
  }
  ngOnChanges(changes: SimpleChanges): void {
    if (!this.cardForm) {
      this.formInit();
    }
    if (changes && changes.showZip) {
      if (changes.showZip.currentValue) {
        this.cardForm.addControl('zipcode', this.zipcode = new FormControl('', [
          Validators.required
        ]));
      } else {
        if (this.cardForm.get('zipcode')) {
          this.cardForm.removeControl('zipcode');
        }
      }
    }
  }
  formInit() {
    this.cardForm = new FormGroup({
      cardNumber: this.cardNumber = new FormControl('', [Validators.required]),
      cardExpiry: this.cardExpiry = new FormControl('', [Validators.required, Validators.minLength(4)]),
      nameOnCard: this.nameOnCard = new FormControl('', [Validators.required]),
      cardCvv: this.cardCvv = new FormControl('', [Validators.required]),
    });
    this.variablesService.userData.subscribe({
      next: (res) => {
        if (res) {
          this.userdata = res;
          this.nameOnCard.setValue(res.full_name);
        }
      }
    });
  }
  /**If the card is prefilled with cards details and user try to delete
   * then it will reset the entire card input values
  */
  resetLastOrderValues(event) {
    if (this.lastOrderInfo.show) {
      this.lastOrderInfo.show = false;
      this.cardNumber.setValue('');
      this.cardPrefix = '';
      this.cardNumberMask = '0000 0000 0000 0000';
      event.target.value = '';
    }
  }
  /**Check the card number and get the details */
  validateCardNumber(event) {
    this.resetLastOrderValues(event);
    if (event.target.value && typeof cardValidator !== 'undefined') {
      this.card = cardValidator(event.target.value);
      this.cardDetails = this.card.getCardDetails();
      this.cardNumberMask = this.addMask(this.cardDetails.max_length, this.cardDetails.gaps);
      if (this.cardDetails.cvv_length) {
        if (!this.cardCvv) {
          this.cardForm.addControl('cardCvv', this.cardCvv = new FormControl('', [Validators.required]));
        }
        this.cardCvvMask = this.addMask(this.cardDetails.cvv_length[this.cardDetails.cvv_length.length - 1]);
      } else {
        this.cardForm.removeControl('cardCvv');
        this.cardCvv = undefined;
      }
      for (const key of Object.keys(this.option)) {
        this.addedCard = this.cardDetails.card_type;
        if (this.cardDetails.card_type.toUpperCase().includes(key)) {
          this.addedValidCard = key;
          break;
        } else {
          this.addedValidCard = null;
        }
      }
    }
  }
  /**Check the card expiry */
  @HostListener('blur', [])
  validateCardNumberOnBlur(event) {
    this.resetLastOrderValues(event);
    if (event.target.value) {
      this.addValidations(this.cardDetails);
    }
  }
  /**Check the card expiry */
  @HostListener('blur', [])
  validateCardExp(event, direct?) {
    this.expiryNumber = direct ? event : event.target.value;
    const exp: string = this.expiryNumber?.replace(/\s/g, '');
    const temp: string[] = exp?.split('/');
    if (this.expiryNumber && this.card) {
      if (temp.length > 1 && temp[1].length === 2) {
        temp[1] = '20' + temp[1];
        this.addErrorInControl('cardExpiry', this.card.validateExpiry(temp.join('/')));
      } else {
        this.addErrorInControl('cardExpiry', this.card.validateExpiry(exp));
      }
    }
  }
  /**Check the card cvv number */
  @HostListener('blur', [])
  validateCardCvv(event) {
    if (event?.target?.value && this.card) {
      this.addErrorInControl('cardCvv', this.card.validateCvv(event.target.value));
    }
  }

  /**Add the validations into control */
  addValidations(data) {
    this.addErrorInControl('cardNumber', data.valid, 'cardNumber');
    if (this.cardCvv) {
      this.cardCvv.setValidators([
        Validators.required,
        Validators.minLength(data.cvv_length[0]),
        Validators.maxLength(data.cvv_length[data.cvv_length.length - 1])
      ]);
      this.cardCvv.updateValueAndValidity();
    }
  }
  /**add error */
  addErrorInControl(control: string, data, name?) {
    if (data) {
      this.cardForm.controls[control].setErrors({ 'invalid': null });
      this.cardForm.controls[control].setValidators([Validators.required]);
      this.cardForm.controls[control].updateValueAndValidity();
    } else {
      this.cardForm.controls[control].setErrors({ 'invalid': true });
    }
    // if (name === 'cardNumber' && this.addedCard) {
    //   this.cardForm.controls[control].setErrors({ 'nosupport': null });
    //   this.cardForm.controls[control].updateValueAndValidity();
    // } else if (name === 'cardNumber' && !this.addedCard) {
    //   this.cardForm.controls[control].setErrors({ 'nosupport': true });
    // }
  }
  /**add masking to the input */
  addMask(length, gaps?) {
    let mask = '';
    for (let i = 1; i <= length; i++) {
      mask = mask.concat('0');
    }
    if (gaps) {
      for (let i = 0; i < gaps.length; i++) {
        mask = mask.substr(0, (gaps[i] + i)) + ' ' + mask.substr(gaps[i] + i);
      }
    }
    return mask;
  }
  /**Get cart response */
  getCartDetails() {
    this.paymentUtilService.cartResponse.subscribe({
      next: (res) => {
        this.cartResponse = res;
        if (this.cartResponse) {
          this.nameOnCard.setValue(this.cartResponse.donor_name);
          this.subs.push(this.variablesService.lastOrderInfo.subscribe({
            next: (res2) => {
              if (
                res2 &&
                res2.mode === 'CARD' &&
                this.cartResponse?.currency === res2.iso_currency &&
                (this.type === 'recuring' && res2.iso_currency !== 'INR') &&
                res2.customer_id &&
                !this.cartResponse?.skipCardPrefil
              ) {
                this.lastOrderInfo = res2;
                this.lastOrderInfo.show = true;
                this.cardNumberMask = '0000';
                this.cardNumber.setValue(+this.lastOrderInfo.last4);
                this.cardPrefix = '**** **** **** ';
              }
            }
          }));
        }
      }
    });
  }

  /**Submit the card form */
  onSubmit() {
    if (!this.lastOrderInfo.show) {
      this.validateCardExp(this.expiryNumber, true);
    }
    if (!this.addedValidCard) {
      const pageEvent = {
        eventName: 'invalid_mode_value',
        event_type: 'payment',
        page_name: this.variablesService.pageName,
        info_1: this.cardNumber.value.substring(0, 4)
      };
      this.events.sendSystemEvent(pageEvent).subscribe(_ => _);
      this.cardForm.controls['cardNumber'].setErrors({ 'nosupport': true });
      return false;
    }
    if (this.cardForm.valid || this.lastOrderInfo.show) {
      const data = {
        'mode': 'CARD',
        'card_name_fill': this.userdata?.full_name || '',
      };
      if (this.lastOrderInfo.show) {
        data['mode_value'] = this.lastOrderInfo.mode_value;
        data['customer_id'] = this.lastOrderInfo.customer_id;
      } else {
        const exp = this.expiryNumber?.replace(/\s+/g, '')?.trim()?.split('/');
        data['mode_value'] = this.addedValidCard?.toUpperCase();
        data['card_month_fill'] = exp?.[0];
        data['card_year_fill'] = exp?.[1];
        data['card_number_fill'] = this.cardNumber.value.toString().trim();
        data['card_cvv_fill'] = this.cardCvv.value;
      }
      if (this.showZip) {
        data['donor_pincode'] = this.zipcode.value;
      }
      this.dataEmit.emit(data);
    } else {
      this.utilService.checkValidForm(this.cardForm);
    }
  }

  ngOnDestroy() {
    this.subs.forEach(s => s.unsubscribe());
  }

}
